module.exports = __webpack_public_path__ + "img/bowling.9456046d.svg";